export default "__VITE_ASSET__b773fbaf__"